import React, { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { updateProfile, uploadPhoto, getProfile } from '../api';

function Profile() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user'));
  const [profile, setProfile] = useState({
    bio: '',
    interests: '',
    looking_for: '',
    latitude: null,
    longitude: null,
    location_name: ''
  });
  const [preview, setPreview] = useState(null);
  const [photoFile, setPhotoFile] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [locationLoading, setLocationLoading] = useState(false);
  const [locationSet, setLocationSet] = useState(false);

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const response = await getProfile();
        const data = response.data;
        if (data.bio) {
          setProfile({
            bio: data.bio || '',
            interests: data.interests || '',
            looking_for: data.looking_for || '',
            latitude: data.latitude || null,
            longitude: data.longitude || null,
            location_name: data.location_name || ''
          });
          if (data.location_name) setLocationSet(true);
          if (data.photo) setPreview(data.photo);
        }
      } catch (err) {
        console.error('Error loading profile:', err);
      }
    };
    loadProfile();
  }, []);

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handlePhoto = (e) => {
    const file = e.target.files[0];
    setPhotoFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const getLocation = () => {
    setLocationLoading(true);
    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser');
      setLocationLoading(false);
      return;
    }
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
          );
          const data = await response.json();
          const city = data.address?.city || data.address?.town || data.address?.state || 'Unknown';
          const country = data.address?.country || '';
          setProfile(prev => ({
            ...prev,
            latitude,
            longitude,
            location_name: `${city}, ${country}`
          }));
          setLocationSet(true);
        } catch {
          setProfile(prev => ({ ...prev, latitude, longitude, location_name: 'Location set' }));
          setLocationSet(true);
        }
        setLocationLoading(false);
      },
      (err) => {
        setError('Could not get your location. Please allow location access.');
        setLocationLoading(false);
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      if (photoFile) {
        const formData = new FormData();
        formData.append('photo', photoFile);
        await uploadPhoto(formData);
      }
      await updateProfile(profile);
      const updatedUser = { ...user, hasProfile: true };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      navigate('/swipe');
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong');
    }
    setLoading(false);
  };

  return (
    <div className="container">
      <div className="hero">
        <p className="auth-eyebrow">✦ Kami Cupid</p>
        <h1 className="auth-title">Your<br />Profile</h1>
        <p className="auth-divider">— ✦ —</p>
        <p className="tagline">Tell us about yourself, {user?.name}</p>
        {error && <p className="auth-error">{error}</p>}

        <div className="photo-upload">
          {preview ? (
            <img src={preview} alt="Profile" className="photo-preview" />
          ) : (
            <div className="photo-placeholder">📷</div>
          )}
          <input
            type="file"
            accept="image/*"
            onChange={handlePhoto}
            id="photo-input"
            style={{ display: 'none' }}
          />
          <label htmlFor="photo-input" className="btn-login">
            Choose Photo
          </label>
        </div>

        <form onSubmit={handleSubmit} className="form">
          <textarea
            name="bio"
            placeholder="Write a short bio about yourself..."
            value={profile.bio}
            onChange={handleChange}
            required
            rows={3}
          />
          <input
            type="text"
            name="interests"
            placeholder="Your interests (e.g. hiking, music, cooking)"
            value={profile.interests}
            onChange={handleChange}
            required
          />
          <select
            name="looking_for"
            value={profile.looking_for}
            onChange={handleChange}
            required
          >
            <option value="">Looking for...</option>
            <option value="relationship">A serious relationship</option>
            <option value="casual">Something casual</option>
            <option value="friendship">Friendship</option>
            <option value="unsure">Not sure yet</option>
          </select>

          <div style={{ textAlign: 'center', margin: '10px 0' }}>
            {locationSet ? (
              <p style={{ color: 'var(--rose)', fontSize: '14px' }}>
                📍 {profile.location_name}
              </p>
            ) : (
              <button
                type="button"
                className="btn-login"
                onClick={getLocation}
                disabled={locationLoading}
                style={{ width: '100%' }}
              >
                {locationLoading ? 'Getting location...' : '📍 Share My Location'}
              </button>
            )}
          </div>

          <button type="submit" className="btn-signup" disabled={loading}>
            {loading ? 'Saving...' : 'Save & Find Matches'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Profile;
